import {
  ACTIONS_LIST_ROUTE_NAME,
  ACTIONS_NAME,
  ALERTS_LIST_ROUTE_NAME,
  ALERTS_OVERVIEW_ROUTE_NAME,
  ALERTS_ROUTE_NAME,
  COMPLETED_TASKS_BY_GROUP_ROUTE_NAME,
  COMPLETED_TASKS_LAYOUT_ROUTE_NAME,
  COMPLETED_TASKS_OVERVIEW_ROUTE_NAME,
  COMPLETED_TASKS_ROUTE_NAME,
  CYCLE_TIME_DIAGRAM,
  DAILY_ROUND_CHECKPOINTS_LIST_ROUTE_NAME,
  DAILY_ROUND_CHECKPOINTS_OVERVIEW_ROUTE_NAME,
  DAILY_ROUND_CHECKPOINTS_ROUTE_NAME,
  DAILY_ROUND_LIST_ROUTE_NAME,
  DAILY_ROUND_LOGBOOK_ROUTE_LIST_NAME,
  DAILY_ROUND_LOGBOOK_ROUTE_NAME,
  DAILY_ROUND_WEEKLY_ROUTE_NAME,
  FACE_TO_FACE_ROUTE_NAME, GEMBA_WALK_BY_CHECKPOINT_LIST_ROUTER_NAME, GEMBA_WALK_CHECKPOINTS_LIST_ROUTE_NAME,
  GEMBA_WALK_CHECKPOINTS_OVERVIEW_ROUTE_NAME,
  GEMBA_WALK_CHECKPOINTS_ROUTE_NAME,
  GEMBA_WALK_LIST_ROUTE_NAME,
  GEMBA_WALK_MENU_BY_CHECKPOINT_TOKEN,
  HSE_RISKS_LIST_ROUTE_NAME,
  HSE_RISKS_OVERVIEW_ROUTE_NAME,
  HSE_RISKS_ROUTE_NAME,
  IMPROVEMENT_IDEAS_LIST_ROUTE_NAME,
  IMPROVEMENT_IDEAS_NAME,
  IMPROVEMENT_IDEAS_OVERVIEW_ROUTE_NAME,
  LINE_BOARD_MANAGEMENT_OVERVIEW_ROUTE_NAME,
  MENU_LIST_TOKEN,
  MENU_OVERVIEW_TOKEN,
  OK_FIRST_PART_BY_CHECKPOINT_LIST_ROUTER_NAME,
  OK_FIRST_PART_MENU_BY_CHECKPOINT_TOKEN,
  OK_FIRST_PART_OVERVIEW_ROUTE_NAME,
  OK_FIRST_PART_ROUTE_NAME,
  OK_FIRST_PART_SCHEDULE_LIST_ROUTE_NAME,
  OK_FIRST_PART_TASK_DEFINITION_ROUTE_NAME,
  PEOPLE_DETAILS_ROUTE_NAME,
  PROBLEM_SOLVING_LIST_ROUTE,
  ROTATION_TABLE_DETAIL_ROUTE_NAME,
  ROTATION_TABLE_ROUTE_NAME,
  ROTATION_TABLE_WORKING_TIME_REPORT_ROUTE_NAME,
  SETTINGS_IMPROVEMENT_IDEAS_DETAILS_ROUTE_NAME,
  SETTINGS_PROBLEM_SOLVING_ACTION_CATEGORIES,
  SETTINGS_VS_ERGONOMICS_LIST_ROUTE,
  SHOP_FLOOR_MANAGEMENT_OVERVIEW_ROUTE_NAME,
  SKILL_MATRIX_LIST_ROUTE_NAME, SKILL_MATRIX_SETTINGS_PEOPLE_IDENTIFIER_FORMAT_NAME,
  TASK_ASSIGNMENT_ROUTE_NAME,
  TASK_GROUPS_PLANNING_ROUTE_NAME,
  TASK_GROUPS_ROUTE_NAME,
  TASK_LIST_ROUTE_NAME,
  VISUAL_STANDARD_EVALUATION_RESULTS_ROUTE,
} from 'frontend/routes/constants'
import { COMPLETED_TASKS_LIST_ROUTE_NAME } from 'frontcore/constants/route-names'
import { CONFIGURATION_KEYS } from 'frontcore/constants/constants'
import {
  GEMBA_WALK_ASSESSMENTS_GRAPH_SETTINGS_ROUTE,
  GEMBA_WALK_CATEGORIES,
  GEMBA_WALK_KPIS,
  GEMBA_WALK_PREVIOUS_COMMENTS_TIME_SETTINGS_ROUTE,
} from 'frontend/constants/gembaWalk'
import { HSE_PRIORITIES_ORIGIN } from 'frontend/constants/hse'
import {
  INTERVENTION_MODES,
  SUPER_CATEGORIES,
  TASK_MANAGER_ASSESSMENTS_GRAPH_SETTINGS_ROUTE,
  TECHNICAL_MODULES,
} from 'frontcore/constants/taskManager'
import { MASTER_AUDIT_SOURCE } from 'frontend/constants/audit'
import { OK_FIRST_PART_LAUNCH_REASONS } from 'frontend/constants/okFirstPart'
import { PPE_MANAGEMENT, TOOL_MANAGEMENT } from 'frontcore/constants/ppe'
import { SWR_SETTINGS_TOLERANCE } from 'frontend/constants/standardWorkReview'

export const STANDARD_CONSOLIDATE_PERMISSION = 'perimeters_as_consolidate_supervisor'
export const STANDARD_CREATE_PERMISSION = 'perimeters_as_create_supervisor'
export const STANDARD_OPERATORS = 'perimeters_as_operator'
export const STANDARD_OVERALL_CREATE_PERMISSION = 'is_overall_create_supervisor'
export const STANDARD_OVERALL_APPROVE_PERMISSION = 'is_overall_approve_supervisor'
export const STANDARD_OVERALL_OPERATOR = 'is_overall_operator'
export const CHIP_BLUE = 'blue lighten-4'
export const CHIP_DISABLED = 'grey lighten-2'
export const TYPE_PERIMETER = 0
export const TYPE_PATTERN = 1

export const CATEGORIES_SETTINGS_ROUTE = 'settings-categories'
export const CATEGORIES_DETAILS_SETTINGS_ROUTE = 'settings-category'
export const WEEKLY_MEETING_SETTINGS_ROUTE_NAME = 'settings-weekly-meeting-dr'
export const WEEKLY_MEETING_SETTINGS_ROUTE = 'settings-weekly-meeting'

export const PRODUCTION_HIERARCHY_ENTITY_TOKEN = 'common.messages.production_hierarchy_'
export const PRODUCTION_HIERARCHY_SETTINGS_SUFFIX = '-definition'

export const SETTINGS_CARDS_TOKENS = {
  settingsOverview: {
    name: 'settings-overview',
  },
  alerts: {
    name: 'settings-alerts',
    token: 'alerts.messages.alert',
  },
  alertLevels: {
    name: 'settings-alert-levels',
    token: 'alerts.messages.alert_levels',
  },
  alertTemplates: {
    name: 'settings-alert-templates',
    token: 'alerts.messages.alert_templates',
  },
  alertChartsTablesConfiguration: {
    name: 'settings-alerts-chartstable-config',
    token: 'settings.messages.charts_table_configuration',
  },
  auditsPlannerConfiguration: {
    name: (source) => `settings-planner-configuration-${source}`,
    token: 'audits.messages.planner_configuration',
  },
  settingTemplateConfiguration: {
    name: (source) => `settings-template-${source}`,
    token: 'settings.messages.option_audit_templates',
  },
  settingObserverConfiguration: {
    name: (source) => `settings-people-permissions-${source}`,
    token: 'settings.messages.option_people_permissions',
  },
  configSettingsOverview: {
    name: 'settings-system',
  },
  configSettings: {
    name: 'settings-system-config',
  },
  templateVersionsConfiguration: {
    name: (source) => `template-versions-${source}`,
  },
  templateVersionsDetailConfiguration: {
    name: (source) => `template-version-detail-${source}`,
  },
  templateCriterionDetailConfiguration: {
    name: (source) => `template-criterion-detail-${source}`,
  },
  templateCriterionNewConfiguration: {
    name: (source) => `template-criterion-new-${source}`,
  },
  templateCriterionNewWithFamilyConfiguration: {
    name: (source) => `template-criterion-new-with-family-${source}`,
  },
  auditsTemplateAssignmentConfiguration: {
    name: (source) => `template-assignment-${source}`,
    token: 'common.messages.menu_master_audit_template_assignment',
  },
  auditsPreviousCommentsTimeConfiguration: {
    name: (source) => `settings-previous-comments-time-config-${source}`,
    token: 'settings.messages.previous_comments_time_config',
  },
  auditsSubtypesConfiguration: {
    name: (source) => `settings-audits-subsource-config-${source}`,
    token: 'settings.messages.configure_audit_subtype',
  },
  masterAuditChartstableConfig: {
    name: `settings-chartstable-config-master-audit`,
    token: 'settings.messages.charts_table_configuration',
  },
  people: {
    name: 'settings-person-card',
    token: 'common.messages.people',
  },
  importPeople: {
    name: 'settings-import-people',
    token: 'settings.messages.people_bulk_import',
  },
  peopleSettings: {
    name: 'settings-people',
    token: 'settings.messages.option_people',
  },
  peopleSettingsConfig: {
    name: 'settings-people-config',
  },
  peopleSettingsDetails: {
    name: PEOPLE_DETAILS_ROUTE_NAME,
  },
  peopleDepartments: {
    name: 'settings-departments',
    token: 'settings.messages.option_departments',
  },
  peopleTeams: {
    name: 'settings-teams',
    token: 'settings.messages.option_teams',
  },
  perimeters: {
    name: 'settings-perimeters-card',
    token: 'common.messages.structure',
  },
  perimeterCreation: {
    name: 'settings-perimeters-creation',
    token: 'settings.messages.perimeter_creation',
  },
  roleSettings: {
    name: 'settings-roles',
  },
  roleSettingsDetails: {
    name: 'settings-roles-details',
  },
  actions: {
    name: 'settings-actions-card',
    token: 'common.messages.menu_actions',
  },
  actionsSource: {
    name: 'settings-actions-source',
    token: 'settings.messages.source_configuration',
  },
  actionsNotification: {
    name: 'settings-actions-notifications',
    token: 'settings.messages.actions_notifications_configuration',
  },
  actionsCategories: {
    name: 'settings-action-categories',
    token: 'settings.messages.action_categories_configuration',
  },
  actionsPriorities: {
    name: 'settings-action-priorities',
    token: 'settings.messages.action_priorities_configuration',
  },
  actionsOnlyOwner: {
    name: 'settings-action-only-owner',
    token: 'settings.messages.only_creator_configuration',
  },
  actionDetails: {
    name: 'settings-action-details',
    token: 'settings.messages.action_details_configuration_menu',
  },
  MasterAuditCard: {
    name: 'settings-master-audit-card',
    token: 'common.messages.menu_audits',
  },
  gembaWalk: {
    name: 'settings-gemba-walk',
    token: 'gemba_walk.messages.gemba_walk_configuration',
  },
  gembaWalkCategories: {
    name: 'settings-gemba-walk-categories',
    token: 'gemba_walk.messages.gemba_walk_categories_configuration',
  },
  gembaWalkKPIs: {
    name: 'settings-gemba-walk-kpis',
    token: 'gemba_walk.messages.gemba_walk_kpis_configuration',
  },
  gembaWalkAssessmentsGraph: {
    name: GEMBA_WALK_ASSESSMENTS_GRAPH_SETTINGS_ROUTE,
    token: 'settings.messages.assessments_result_graph_configuration',
  },
  gembaWalkPreviousCommentsTime: {
    name: GEMBA_WALK_PREVIOUS_COMMENTS_TIME_SETTINGS_ROUTE,
    token: 'settings.messages.previous_comments_time_config',
  },
  gembaWalkChartConfiguration: {
    name: 'settings-gemba-walk-kpi-charts-config',
    token: 'settings.messages.charts_table_configuration',
  },
  gembaWalkByCheckpointChartConfiguration: {
    name: 'settings-gemba-walk-by-checkpoint-charts-config',
    token: 'settings.messages.by_checkpoint_charts_table_configuration',
  },
  shifts: {
    name: 'settings-shifts',
    token: 'settings.messages.shift_management',
  },
  ppes: {
    name: 'ppe-settings-card',
    token: 'settings.messages.ppe_management',
  },
  ppeConfiguration: {
    name: PPE_MANAGEMENT,
    token: 'settings.messages.ppe_configuration',
  },
  toolConfiguration: {
    name: TOOL_MANAGEMENT,
    token: 'settings.messages.tool_configuration',
  },
  problemSolving: {
    name: 'problem-resolution-card',
    token: 'common.messages.menu_problem_solving',
  },
  skillMatrix: {
    name: 'skill-matrix-settings',
    token: 'common.messages.menu_standard_ilu_matrix',
  },
  importSkillMatrix: {
    name: 'settings-import-skill-matrix',
    token: 'settings.messages.ILUO_levels_bulk_import',
  },
  peopleIdentifierFormat: {
    name: SKILL_MATRIX_SETTINGS_PEOPLE_IDENTIFIER_FORMAT_NAME,
    token: "settings.messages.skill_matrix_configure_people_display",
  },
  problemSolvingConfiguration: {
    name: 'settings-problem-solving',
    token: 'settings.messages.option_configure_problem',
  },
  problemSolvingCauseCategories: {
    name: 'settings-cause-categories',
    token: 'settings.messages.option_cause_categories',
  },
  problemSolvingCategories: {
    name: 'settings-problem-categories',
    token: 'settings.messages.option_problem_categories',
  },
  problemSolvingMTool: {
    name: 'settings-mtools',
    token: 'settings.messages.option_mtool_templates',
  },
  problemSolving6MTool: {
    name: 'settings-sixmtools',
    token: 'settings.messages.option_sixmtool_templates',
  },
  problemSolvingDocReview: {
    name: 'settings-documentation-review',
    token: 'settings.messages.option_configure_documentation_review',
  },
  problemSolvingAnalysisTool: {
    name: 'settings-problem-solving-causetool',
    token: 'settings.messages.option_configure_causetool',
  },
  problemSolvingActionPlanEfficiencyConfiguration: {
    name: 'settings-problem-solving-plan-efficiency-config',
    token: 'settings.messages.option_configure_action_plan_effectiveness',
  },
  problemSolvingChartsTablesConfiguration: {
    name: 'settings-problem-solving-chartstable-config',
    token: 'settings.messages.charts_table_configuration',
  },
  problemSolvingCloseTools: {
    name: 'settings-close-problem-configuration',
    token: 'settings.messages.problem_close_tools',
  },
  problemSolvingActionCategories: {
    name: SETTINGS_PROBLEM_SOLVING_ACTION_CATEGORIES,
    token: 'settings.messages.problem_action_categories',
  },
  visualStandard: {
    name: 'settings-standard-viewer-card',
    token: 'common.messages.menu_standards',
  },
  visualStandardPermissions: {
    name: 'settings-standard-permissions',
    token: 'settings.messages.option_standard_permissions',
  },
  visualStandardViewerConfiguration: {
    name: 'standard-viewer-configuration',
    token: 'settings.messages.standard_viewer_configuration',
  },
  visualStandardErgonomicsLevelsConfiguration: {
    name: SETTINGS_VS_ERGONOMICS_LIST_ROUTE,
    token: 'settings.messages.standard_ergonomics_levels_configuration',
    children: {
      details: 'standard-ergonomics-levels-configuration-detail',
    },
  },
  visualStandardProductionConfigurations: {
    name: 'standard-production-configurations',
    token: 'settings.messages.define_standard_production_configurations',
    children: {
      details: 'standard-production-configurations-detail',
    },
  },
  standardAbilityCertifications: {
    name: 'standard-ability-certifications',
    token: 'settings.messages.define_standard_ability_certifications',
    children: {
      details: 'standard-ability-certification-details',
    },
  },
  visualStandardIndicatorsAndChartsConfiguration: {
    name: 'standard-kpi-charts-config',
    token: 'settings.messages.charts_table_configuration',
  },
  settingsOrganization: {
    name: 'settings-sr-characteristics',
    token: 'common.messages.reglamentation_points',
  },
  visualStandardRSRSCharacteristics: {
    name: 'standard-sequence-rsrs-characteristics',
    token: 'settings.messages.sequence_rsrs_characteristics',
    children: {
      details: 'standard-sequence-rsrs-characteristic-detail',
    },
  },
  presentationNotification: {
    name: 'settings-presentation-notifications',
    token: 'settings.messages.presentation_notifications_configuration',
  },
  alert: {
    name: 'settings-fa-warning-card',
    token: 'common.messages.menu_alert_manager',
  },
  alertCriterionType: {
    name: 'settings-alert-criterion-type',
    token: 'settings.messages.alert_configuration_edit',
  },
  alertGQPCriterionType: {
    name: 'settings-alert-gqp-criterion-type',
    token: 'settings.messages.alert_gqp_configuration_edit',
  },
  alertTypology: {
    name: 'settings-risk-typology-alert',
    token: 'settings.messages.risk_typology_alert',
  },
  swr: {
    name: 'standard-work-review-card',
    token: 'common.messages.menu_standard_work_review',
  },
  swrTolerance: {
    name: SWR_SETTINGS_TOLERANCE,
    token: 'settings.messages.set_tolerance_card',
  },
  settingsSWRKpis: {
    name: 'swr-kpi-charts-config',
    token: 'settings.messages.charts_table_configuration',
  },
  hseRisks: {
    name: 'settings-hse-risks',
    token: 'settings.messages.hse_risk_section_title',
  },
  hseRiskCategories: {
    name: 'settings-hse-risk-categories',
    token: 'settings.messages.hse_risk_subsection_title_categories',
  },
  hseRiskPriorities: {
    name: 'settings-hse-risk-priorities',
    token: 'settings.messages.hse_risk_subsection_title_priorities',
  },
  sfm: {
    name: 'sfm-settings',
    token: 'common.messages.sfm',
  },
  sfmTopics: {
    name: 'sfm-topics-settings',
    token: 'settings.messages.sfm_settings_manage_topics_title',
  },
  sfmTopicsDetails: {
    name: 'sfm-topics-details-settings',
  },
  sfmCheckpoints: {
    name: 'sfm-checkpoints-settings',
    token: 'common.messages.review_point',
  },
  sfmAttachments: {
    name: 'sfm-manage-line-board-attachments-settings',
    token: 'settings.messages.manage_global_line_board_attachments',
  },
  sfmCheckpointsDetails: {
    name: 'sfm-checkpoints-settings-details',
  },
  tpm: {
    name: 'settings-tpm-card',
    token: 'sources.messages.task_manager',
  },
  tpmCategories: {
    name: 'settings-categories-tpm',
    token: 'settings.messages.configure_tpm_categories_option',
  },
  tpmSuperCategories: {
    name: 'settings-tpm-super-categories',
    token: 'settings.messages.configure_super_categories_option',
  },
  tpmSuperCategoriesList: {
    name: 'settings-tpm-super-categories-list',
  },
  tpmSuperCategoriesDetails: {
    name: 'settings-tpm-super-categories-details',
  },
  tpmInterventionModes: {
    name: 'settings-tpm-intervention-modes',
    token: 'settings.messages.configure_intervention_modes_option',
  },
  tpmTechnicalModules: {
    name: 'settings-tpm-technical-modules',
    token: 'settings.messages.configure_technical_modules_option',
  },
  tpmConfigureOptions: {
    name: 'settings-tpm-configure-options',
    token: 'settings.messages.tpm_configure_options',
  },
  tpmAssessmentHistoryGraph: {
    name: TASK_MANAGER_ASSESSMENTS_GRAPH_SETTINGS_ROUTE,
    token: 'settings.messages.assessments_result_graph_configuration',
  },
  tpmPreviousCommentsTime: {
    name: 'settings-tpm-previous-comments-time-config',
    token: 'settings.messages.previous_comments_time_config',
  },
  tpmTasksCreation: {
    name: TASK_LIST_ROUTE_NAME,
    token: 'settings.messages.tpm_tasks_creation_config',
  },
  tpmTasksAssignment: {
    name: TASK_ASSIGNMENT_ROUTE_NAME,
    token: 'settings.messages.tpm_tasks_assignment_config',
  },
  tpmTasksGroups: {
    name: TASK_GROUPS_ROUTE_NAME,
    token: 'settings.messages.tpm_tasks_groups_config',
  },
  tpmTasksPlanification: {
    name: TASK_GROUPS_PLANNING_ROUTE_NAME,
    token: 'settings.messages.tpm_tasks_planification_config',
  },
  drCheckpoints: {
    name: 'settings-dr-checkpoints-card',
    token: 'common.messages.menu_dailyround_cockpit',
  },
  drCheckpointsCategories: {
    name: 'settings-categories-dr',
    token: 'settings.messages.configure_categories_option',
  },
  drCheckpointsWeeklyMeeting: {
    name: WEEKLY_MEETING_SETTINGS_ROUTE_NAME,
    token: 'settings.messages.configure_weekly_meeting',
  },
  drCheckpointsTimeTrackingCategory: {
    name: 'settings-time-tracking-category',
    token: 'settings.messages.configure_time_tracking_categories',
  },
  drPreviousCommentsTime: {
    name: 'settings-dr-previous-comments-time-config',
    token: 'settings.messages.previous_comments_time_config',
  },
  drChartConfiguration: {
    name: 'settings-dr-kpi-charts-config',
    token: 'settings.messages.charts_table_configuration',
  },
  productionFormat: {
    name: 'product-definition-config',
    token: 'settings.messages.menu_format_definition',
  },
  importProducts: {
    name: 'settings-import-products',
    token: 'settings.messages.products_bulk_import',
  },
  productionFormatCreation: {
    name: 'product-definition',
    token: 'settings.messages.management_title',
  },
  improvementIdeas: {
    name: 'settings-improvement-ideas-card',
    token: 'improvement_idea.messages.menu_improvement_ideas',
  },
  improvementIdeasChartstableConfig: {
    name: 'settings-chartstable-config-improvement-ideas',
    token: 'settings.messages.charts_table_configuration',
  },
  improvementIdeasCategoriesConfig: {
    name: 'settings-improvement-ideas-categories',
    token: 'settings.messages.improvement_ideas_categories_configuration',
  },
  improvementIdeasFieldsByRoleConfig: {
    name: 'settings-improvement-ideas-fields-by-role-config',
    token: 'settings.messages.improvement_ideas_fields_by_role',
  },
  improvementIdeasDetailsConfig: {
    name: SETTINGS_IMPROVEMENT_IDEAS_DETAILS_ROUTE_NAME,
    token: 'settings.messages.ii_details_configuration',
  },
  okFirstPart: {
    name: 'settings-ok-first-part',
    token: 'common.messages.menu_ok_first_part',
  },
  okFirstPartCategories: {
    name: 'settings-ok-first-part-categories',
    token: 'ok_first_part.messages.ok_first_part_categories',
  },
  okFirstPartOverviewConfig: {
    name: 'settings-ok-first-part-kpis',
    token: 'settings.messages.charts_table_configuration',
  },
  okFirstPartLaunchReasons: {
    name: 'settings-ok-first-part-launch-reasons',
    token: 'ok_first_part.messages.ok_first_part_launch_reasons',
  },
  okFirstPartConfigureOptions: {
    name: 'settings-ok-first-part-configure-options',
    token: 'ok_first_part.messages.ofp_configure_options',
  },
  okFirstPartEmails: {
    name: 'settings-ok-first-part-emails',
    token: 'ok_first_part.messages.ok_first_part_emails',
  },
  okFirstPartByCheckpointChartConfiguration: {
    name: 'settings-ok-first-part-by-checkpoint-charts-config',
    token: 'settings.messages.by_checkpoint_charts_table_configuration',
  },
  okFirstPartTaskDefinition: {
    name: OK_FIRST_PART_TASK_DEFINITION_ROUTE_NAME,
    token: 'settings.messages.configure_control_points',
  },
  selfAssessments: {
    name: 'settings-self-assessments',
    token: 'common.messages.menu_self_assessment',
  },
  selfAssessmentsOverviewConfig: {
    name: 'settings-self-assessments-charts',
    token: 'settings.messages.charts_table_configuration',
  },
  diagnosisRolePermissions: {
    name: 'settings-diagnosis-role-options',
    token: 'diagnosis.messages.configure_self_assessment_approval',
  },
  diagnosis: {
    name: 'settings-diagnosis',
    token: 'common.messages.menu_diagnosis',
  },
  productionHierarchyDefinition: {
    name: (level) => `${level}-definition`,
    token: 'settings.messages.management_title',
  },
  productionHierarchyDetails: {
    name: (level) => `${level}-details`,
  },

  consolidatedReportRolePermissions: {
    name: 'settings-consolidated-report-options',
    token: 'common.messages.configure_consolidated_report_approval',
  },
  fundamentalTarget: {
    name: 'settings-fundamental-target-config',
    token: 'settings.messages.configure_fundamental_target',
  },
}

export const DASHBOARD_MODULE_TOKENS = {
  actions: {
    name: ACTIONS_NAME,
    token: 'common.messages.menu_actions',
  },
  actionsOverview: {
    name: 'actions-overview',
    token: MENU_OVERVIEW_TOKEN,
  },
  actionsList: {
    name: ACTIONS_LIST_ROUTE_NAME,
    token: MENU_LIST_TOKEN,
  },
  actionsDetails: {
    name: 'actions-details',
  },
  actionsFollowUp: {
    name: 'actions-follow-up-teams',
    token: 'common.messages.menu_follow_up_teams',
  },
  actionsCalendar: {
    name: 'actions-calendar',
    token: 'common.messages.menu_calendar',
  },
  alerts: {
    name: ALERTS_ROUTE_NAME,
    token: 'alerts.messages.menu_alerts',
  },
  alertsOverview: {
    name: ALERTS_OVERVIEW_ROUTE_NAME,
    token: MENU_OVERVIEW_TOKEN,
  },
  alertsList: {
    name: ALERTS_LIST_ROUTE_NAME,
    token: MENU_LIST_TOKEN,
  },
  home: {
    name: 'home',
    token: 'common.messages.home',
  },
  improvementIdeas: {
    name: IMPROVEMENT_IDEAS_NAME,
    token: 'improvement_idea.messages.menu_improvement_ideas',
  },
  improvementIdeasOverview: {
    name: IMPROVEMENT_IDEAS_OVERVIEW_ROUTE_NAME,
    token: MENU_OVERVIEW_TOKEN,
  },
  improvementIdeasList: {
    name: IMPROVEMENT_IDEAS_LIST_ROUTE_NAME,
    token: MENU_LIST_TOKEN,
  },
  okFirstPart: {
    name: OK_FIRST_PART_ROUTE_NAME,
    token: 'common.messages.menu_ok_first_part',
  },
  okFirstPartList: {
    name: OK_FIRST_PART_SCHEDULE_LIST_ROUTE_NAME,
    token: MENU_LIST_TOKEN,
  },
  okFirstPartOverview: {
    name: OK_FIRST_PART_OVERVIEW_ROUTE_NAME,
    token: MENU_OVERVIEW_TOKEN,
  },
  okFirstPartByCheckpoint: {
    name: OK_FIRST_PART_BY_CHECKPOINT_LIST_ROUTER_NAME,
    token: OK_FIRST_PART_MENU_BY_CHECKPOINT_TOKEN,
  },
  gembaWalk: {
    name: GEMBA_WALK_CHECKPOINTS_ROUTE_NAME,
    token: 'gemba_walk.messages.menu_gemba_walk',
  },
  gembaWalkOverview: {
    name: GEMBA_WALK_CHECKPOINTS_OVERVIEW_ROUTE_NAME,
    token: MENU_OVERVIEW_TOKEN,
  },
  gembaWalkByCheckpoint: {
    name: GEMBA_WALK_BY_CHECKPOINT_LIST_ROUTER_NAME,
    token: GEMBA_WALK_MENU_BY_CHECKPOINT_TOKEN,
  },
  gembaWalkCheckpointsList: {
    name: GEMBA_WALK_CHECKPOINTS_LIST_ROUTE_NAME,
    token: 'gemba_walk.messages.menu_tasks_definition',
  },
  gembaWalkList: {
    name: GEMBA_WALK_LIST_ROUTE_NAME,
    token: MENU_LIST_TOKEN,
  },
  gembaWalkFaceToFace: {
    name: FACE_TO_FACE_ROUTE_NAME,
    token: 'gemba_walk.messages.face_to_face',
  },
  dailyroundCheckpoints: {
    name: DAILY_ROUND_CHECKPOINTS_ROUTE_NAME,
    token: 'common.messages.menu_dailyround_cockpit',
  },
  dailyroundCheckpointsOverview: {
    name: DAILY_ROUND_CHECKPOINTS_OVERVIEW_ROUTE_NAME,
    token: MENU_OVERVIEW_TOKEN,
  },
  dailyroundCheckpointsList: {
    name: DAILY_ROUND_CHECKPOINTS_LIST_ROUTE_NAME,
    token: 'common.messages.menu_activity_definition',
  },
  dailyroundsList: {
    name: DAILY_ROUND_LIST_ROUTE_NAME,
    token: MENU_LIST_TOKEN,
  },
  dailyroundsWeeklyMeeting: {
    name: DAILY_ROUND_WEEKLY_ROUTE_NAME,
    token: 'common.messages.menu_weekly_meeting',
  },
  dailyroundsLogBook: {
    name: DAILY_ROUND_LOGBOOK_ROUTE_NAME,
    token: 'common.messages.messages',
  },
  dailyroundsLogBookList: {
    name: DAILY_ROUND_LOGBOOK_ROUTE_LIST_NAME,
    token: MENU_LIST_TOKEN,
  },
  problemSolving: {
    name: 'problem-solving',
    token: 'common.messages.menu_problem_solving',
  },
  problemSolvingOverview: {
    name: 'problem-solving-overview',
    token: MENU_OVERVIEW_TOKEN,
  },
  problemSolvingList: {
    name: PROBLEM_SOLVING_LIST_ROUTE,
    token: MENU_LIST_TOKEN,
  },
  problemSolvingPlanning: {
    name: 'problem-solving-planning',
    token: 'common.messages.menu_observations_planification',
  },
  problemSolvingExecutiveView: {
    name: 'problem-solving-executive-view',
  },
  problemSolvingDetails: {
    name: 'problem-solving-details',
  },
  rotationTable: {
    name: ROTATION_TABLE_ROUTE_NAME,
    token: 'common.messages.menu_rotation_table',
  },
  rotationTableDetail: {
    name: ROTATION_TABLE_DETAIL_ROUTE_NAME,
    token: MENU_LIST_TOKEN,
  },
  rotationTableWorkingTimeReport: {
    name: ROTATION_TABLE_WORKING_TIME_REPORT_ROUTE_NAME,
    token: MENU_OVERVIEW_TOKEN,
  },
  standards: {
    name: 'standards-viewer',
    token: 'common.messages.menu_standards',
  },
  standardViewer: {
    name: 'standard-viewer',
    token: 'common.messages.standard_viewer',
  },
  standardSummary: {
    name: 'standard-summary',
  },
  standardDetails: {
    name: 'standard-details',
  },
  standardEvaluation: {
    name: 'standard-evaluation',
    token: 'common.messages.menu_standard_evaluation',
  },
  standardOverview: {
    name: 'standard-overview',
    token: MENU_OVERVIEW_TOKEN,
  },
  standardList: {
    name: 'standard-list',
    token: MENU_LIST_TOKEN,
  },
  standardVersionList: {
    name: 'standard-version-list',
    token: MENU_LIST_TOKEN,
  },
  standardSevenWastesList: {
    name: 'seven-wastes-list',
  },
  standardOpenSevenWastesList: {
    name: 'open-seven-wastes-list',
  },
  standardClosedSevenWastesList: {
    name: 'closed-seven-wastes-list',
  },
  standardSevenWasteDetails: {
    name: 'seven-waste-details',
  },
  standardEvaluationResults: {
    name: VISUAL_STANDARD_EVALUATION_RESULTS_ROUTE,
    token: 'common.messages.menu_standard_evaluation_results',
  },
  standardTimeMeasurements: {
    name: 'standard-time-measurements',
  },
  standardTimeMeasurementsList: {
    name: 'standard-time-measurements-list',
  },
  sequenceTimeMeasurementsList: {
    name: 'sequence-time-measurements-list',
  },
  referenceStandard: {
    name: 'reference-standards',
    token: 'common.messages.reference_standards',
  },
  skillMatrix: {
    name: 'skill-matrix',
    token: 'common.messages.menu_standard_ilu_matrix',
  },
  skillMatrixOverview: {
    name: 'skill-matrix-overview',
    token: MENU_OVERVIEW_TOKEN,
  },
  skillMatrixList: {
    name: SKILL_MATRIX_LIST_ROUTE_NAME,
    token: MENU_LIST_TOKEN,
    children: {
      skills: 'skill-matrix-list-skills',
      certifications: 'skill-matrix-list-certifications',
      thresholds: 'skill-matrix-list-thresholds',
    },
  },
  virtualTraining: {
    name: 'virtual-training-viewer',
    token: 'common.messages.menu_virtual_training',
  },
  variantViewer: {
    name: 'variant-viewer',
    token: 'common.messages.menu_activity_viewer',
  },
  variantEvaluation: {
    name: 'variant-evaluation',
    token: 'video_training.messages.evaluation',
  },
  virtualTrainingOverview: {
    name: 'virtual-training-overview',
    token: MENU_OVERVIEW_TOKEN,
  },
  virtualTrainingTestResult: {
    name: 'test-result',
    token: 'video_training.messages.test_results',
  },
  virtualTrainingTestState: {
    name: 'test-state',
    token: 'video_training.messages.workstation_state',
  },
  completedTasks: {
    name: COMPLETED_TASKS_ROUTE_NAME,
    token: 'common.messages.menu_task_manager',
  },
  tpmTasksPlanification: {
    name: TASK_GROUPS_PLANNING_ROUTE_NAME,
    token: 'common.messages.menu_calendar',
  },
  completedTasksOverview: {
    name: COMPLETED_TASKS_OVERVIEW_ROUTE_NAME,
    token: MENU_OVERVIEW_TOKEN,
  },
  completedTasksList: {
    name: COMPLETED_TASKS_LIST_ROUTE_NAME,
    token: MENU_LIST_TOKEN,
  },
  completedTasksGroups: {
    name: COMPLETED_TASKS_BY_GROUP_ROUTE_NAME,
    token: 'task_manager.messages.by_groups',
  },
  completedTasksLayout: {
    name: COMPLETED_TASKS_LAYOUT_ROUTE_NAME,
    token: 'task_manager.messages.perimeter_heatmap_title',
  },
  riskOverviewDetails: {
    name: 'risk-overview-details',
    token: MENU_OVERVIEW_TOKEN,
  },
  diagnosis: {
    name: 'diagnosis',
    token: 'common.messages.menu_diagnosis',
  },
  diagnosisOverview: {
    name: 'diagnosis-overview',
    token: MENU_OVERVIEW_TOKEN,
  },
  diagnosisList: {
    name: 'diagnosis-list',
    token: MENU_LIST_TOKEN,
  },
  diagnosisDetails: {
    name: 'brick-list',
  },
  consolidatedReportInCorp: {
    name: 'consolidated-reports',
    token: 'diagnosis.messages.consolidated_report',
  },
  consolidatedReportInCorpList: {
    name: 'consolidated-reports-list',
    token: MENU_LIST_TOKEN,
  },
  consolidatedReportInCorpDetails: {
    name: 'consolidated-report-corp-detail',
  },
  lpa: {
    name: 'lpa',
    token: 'common.messages.menu_master_audit',
  },
  masterAuditOverview: {
    name: 'master-audit-overview',
    token: MENU_OVERVIEW_TOKEN,
  },
  lpaMasterAuditCalendar: {
    name: 'lpa-calendar',
    token: 'common.messages.menu_calendar',
  },
  selfAssessment: {
    name: 'self-assessment',
    token: 'common.messages.menu_self_assessment',
  },
  consolidatedReportCreation: {
    name: 'consolidated-report-creation',
    token: 'common.messages.menu_consolidated_report_creation',
  },
  consolidatedReportTable: {
    name: 'consolidated-report-table',
    token: 'diagnosis.messages.consolidated_report',
  },
  consolidatedReportDetail: {
    name: 'consolidated-report-detail',
  },
  consolidatedReportDetails: {
    name: 'consolidated-report-details',
  },
  swr: {
    name: 'standard-work-review',
    token: 'common.messages.menu_standard_work_review',
  },
  swrOverview: {
    name: 'swr-overview',
    token: MENU_OVERVIEW_TOKEN,
  },
  swrList: {
    name: 'swr-list',
    token: MENU_LIST_TOKEN,
  },
  swrVariability: {
    name: 'swr-variability',
    token: 'common.messages.menu_swr_variability',
  },
  swaCalendar: {
    name: 'swa-calendar',
    token: 'common.messages.menu_calendar',
  },
  swaMonthlyCalendar: {
    name: 'swa-monthly-calendar',
    token: 'standard_work_review.messages.monthly_calendar',
  },
  swaWeeklyCalendar: {
    name: 'swa-weekly-calendar',
    token: 'standard_work_review.messages.weekly_calendar',
  },
  pageNotFound: {
    name: 'page-not-found',
  },
  overview: {
    name: 'overview',
  },
  hseRisks: {
    name: HSE_RISKS_ROUTE_NAME,
    token: 'common.messages.menu_hse_risks',
  },
  hseRisksList: {
    name: HSE_RISKS_LIST_ROUTE_NAME,
    token: MENU_LIST_TOKEN,
  },
  hseRisksOverview: {
    name: HSE_RISKS_OVERVIEW_ROUTE_NAME,
    token: MENU_OVERVIEW_TOKEN,
  },
  sfm: {
    name: SHOP_FLOOR_MANAGEMENT_OVERVIEW_ROUTE_NAME,
    token: 'common.messages.menu_sfm',
  },
  lineBoard: {
    name: LINE_BOARD_MANAGEMENT_OVERVIEW_ROUTE_NAME,
    configKey: CONFIGURATION_KEYS.LINE_BOARD_NAME,
  },
  cycleTimeDiagram: {
    name: CYCLE_TIME_DIAGRAM,
    token: 'common.messages.menu_cycle_time_diagram',
  },
}

export const APPS_MODULE_TOKENS = {
  leanCenter: {
    name: 'LeanCenter',
    token: 'sources.messages.lean_center_app',
  },
  cockpit: {
    name: 'Cockpit',
    token: 'daily_round_checkpoints.messages.cockpit_app',
  },
  problemSolving: {
    name: 'ProblemSolving',
    token: 'sources.messages.problem_solving',
  },
  visualStandard: {
    name: 'VisualStandard',
    token: 'common.messages.menu_standards',
  },
  vtTeacher: {
    name: 'VideoTrainingTeacher',
    token: 'sources.messages.vt_teacher',
  },
  vtStudent: {
    name: 'VideoTrainingStudent',
    token: 'sources.messages.vt_student',
  },
  masterAudit: {
    name: 'MasterAudit',
    token: 'sources.messages.master_audit',
  },
  swr: {
    name: 'StandardWorkReview',
    token: 'sources.messages.standard_work_review',
  },
  visualStandardAnalysis: {
    name: 'VisualStandardAnalysis',
    token: 'sources.messages.visual_standard_analysis',
  },
  taskManager: {
    name: 'TaskManager',
    token: 'sources.messages.task_manager',
  },
  diagnosis: {
    name: 'Diagnosis',
    token: 'common.messages.menu_diagnosis',
  },
  audit5s: {
    name: 'FiveSMethod',
    token: 'sources.messages.fiveS',
  },
  logistic: {
    name: 'LPALogistics',
    token: 'sources.messages.observation_logistics',
  },
  observation: {
    name: 'Observation',
    token: 'sources.messages.observation',
  },
  audCapLog: {
    name: 'AudCapLog',
    token: 'sources.messages.app_aud_cap_log',
  },
  obsAudit5S: {
    name: 'Aud5S',
    token: 'common.messages.audit_fives',
  },
  hseProduction: {
    name: 'HSEProduction',
    token: 'sources.messages.observation_hse_prod',
  },
  iluo: {
    name: 'ILUO',
    token: 'sources.messages.observation_iluo',
  },
  eightqb: {
    name: 'eightqb',
    token: 'common.messages.eightqb',
  },
  lpas: {
    name: 'LPAS',
    token: 'sources.messages.lpas',
  },
  shiftChange: {
    name: 'ShiftChange',
    token: 'sources.messages.shift_change',
  },
  lpaStock: {
    name: 'LPAStock',
    token: 'common.messages.menu_lpa_stock',
  },
  lpaPaint: {
    name: 'LPAPaint',
    token: 'common.messages.menu_lpa_paint',
  },
  checklist: {
    name: 'Checklist',
    token: 'sources.messages.checklist',
  },
  standards: {
    name: 'Standards',
    token: 'sources.messages.standards',
  },
  machines: {
    name: 'Machines',
    token: 'sources.messages.machines',
  },
  lpaInj: {
    name: 'LPAInj',
    token: 'common.messages.menu_lpa_injection',
  },
  okFirstPart: {
    name: 'OK1stPart',
    token: 'common.messages.menu_ok_first_part',
  },
  hseRisks: {
    name: 'HSERisks',
    token: 'sources.messages.hse_risk',
  },
}

export const RELATED_OBJECTS = Object.freeze({
  'action': 'common.messages.actions',
  'audit': 'audits.messages.audit',
  'checkpoint': 'common.messages.checkpoints',
  'checkpointschedule': 'common.messages.checkpointschedules',
  'checkpointscheduleentry': 'common.messages.checkpointscheduleentrys',
  'dailyround': 'common.messages.dailyrounds',
  'dailyroundmessage': 'common.messages.messages',
  'defect': 'common.messages.defects',
  'deviation': 'common.messages.deviations',
  'improvementidea': 'common.messages.improvement_ideas',
  'instantgroupinschedule': 'common.messages.instantgroupinschedules',
  'okfirstpartassessment': 'ok_first_part.messages.title',
  'perimeter': 'common.messages.perimeters',
  'plannedgroupschedule': 'common.messages.plannedgroupschedules',
  'problem': 'common.messages.problems',
  'referencestate': 'common.messages.referencestates',
  'risk': 'common.messages.risks',
  'riskproductalert': 'common.messages.riskproductalerts',
  'rotationtable': 'common.messages.rotationtables',
  'standard': 'common.messages.standards',
  'template': 'common.messages.templates',
})

export const DEFAULT_CATEGORY_TOKENS = {
  category: 'common.messages.category',
  myCategoryToken: 'settings.messages.categories_list',
  addCategoryToken: 'common.messages.add_category',
  editCategoryToken: 'common.messages.edit_category',
  categoryNameToken: 'common.messages.category_name',
  categoryDescriptionToken: 'settings.messages.category_description',
  enabledFilterToken: 'settings.messages.only_categories_enabled',
}

export const CATEGORY_CUSTOM_TOKENS = {
  [GEMBA_WALK_CATEGORIES]: {
    category: 'common.messages.category',
    myCategoryToken: 'gemba_walk.messages.categories_list',
    addCategoryToken: 'common.messages.add_category',
    editCategoryToken: 'common.messages.edit_category',
    categoryNameToken: 'common.messages.category_name',
    categoryDescriptionToken: 'gemba_walk.messages.category_description',
    enabledFilterToken: 'gemba_walk.messages.only_categories_enabled',
  },
  [GEMBA_WALK_KPIS]: {
    category: 'gemba_walk.messages.kpi',
    myCategoryToken: 'gemba_walk.messages.kpi_list',
    addCategoryToken: 'gemba_walk.messages.add_kpi',
    editCategoryToken: 'gemba_walk.messages.edit_kpi',
    categoryNameToken: 'gemba_walk.messages.kpi_name',
    categoryDescriptionToken: 'gemba_walk.messages.kpi_description',
    enabledFilterToken: 'gemba_walk.messages.only_kpis_enabled',
  },
  [HSE_PRIORITIES_ORIGIN]: {
    category: 'common.messages.priority',
    myCategoryToken: 'hse.messages.priority_list',
    addCategoryToken: 'actions.messages.add_priority',
    editCategoryToken: 'hse.messages.edit_priority_name',
    categoryNameToken: 'hse.messages.priority_name',
    enabledFilterToken: 'hse.messages.only_priorities_enabled',
  },
  [INTERVENTION_MODES]: {
    category: 'task_manager.messages.intervention_mode',
    myCategoryToken: 'task_manager.messages.intervention_mode_list',
    addCategoryToken: 'task_manager.messages.add_intervention_mode',
    editCategoryToken: 'task_manager.messages.edit_intervention_mode',
    categoryNameToken: 'task_manager.messages.intervention_mode_name',
    categoryDescriptionToken: 'task_manager.messages.intervention_mode_description',
    enabledFilterToken: 'task_manager.messages.only_intervention_modes_enabled',
  },
  'root-causes': {
    myCategoryToken: 'problem_solving.messages.cause_root_category_list',
  },
  [TECHNICAL_MODULES]: {
    category: 'task_manager.messages.technical_module',
    myCategoryToken: 'task_manager.messages.technical_module_list',
    addCategoryToken: 'task_manager.messages.add_technical_module',
    editCategoryToken: 'task_manager.messages.edit_technical_module',
    categoryNameToken: 'task_manager.messages.technical_module_name',
    categoryDescriptionToken: 'task_manager.messages.technical_module_description',
    enabledFilterToken: 'task_manager.messages.only_technical_module_enabled',
  },
  [SUPER_CATEGORIES]: {
    category: 'common.messages.supercategory',
    myCategoryToken: 'task_manager.messages.super_category_list',
    addCategoryToken: 'task_manager.messages.add_super_category',
    editCategoryToken: 'task_manager.messages.edit_super_category',
    categoryNameToken: 'task_manager.messages.super_category_name',
    categoryDescriptionToken: 'task_manager.messages.super_category_description',
    enabledFilterToken: 'task_manager.messages.only_super_category_enabled',
  },
  [OK_FIRST_PART_LAUNCH_REASONS]: {
    category: 'ok_first_part.messages.launch_reasons',
    myCategoryToken: 'ok_first_part.messages.launch_reason_list',
    addCategoryToken: 'ok_first_part.messages.add_launch_reason',
    editCategoryToken: 'ok_first_part.messages.edit_launch_reason',
    categoryNameToken: 'ok_first_part.messages.launch_reason_name',
    categoryDescriptionToken: 'ok_first_part.messages.launch_reason_description',
    enabledFilterToken: 'ok_first_part.messages.only_launch_reason_enabled',
  },
  [MASTER_AUDIT_SOURCE]: {
    category: 'audits.messages.subtype',
    myCategoryToken: 'audits.messages.audit_subtypes',
    addCategoryToken: 'audits.messages.add_subtype',
    editCategoryToken: 'audits.messages.edit_subtype',
    categoryNameToken: 'settings.messages.subtype_name',
    categoryDescriptionToken: 'settings.messages.subtype_description',
    enabledFilterToken: 'audits.messages.only_subtype_enabled',
  },
}
